<div class="page">
  <dv-toolbar>
    <img left src="/assets/via_tracks_logo.png" width="250" />
    @if (iconMenuItems().length) {
      <dv-icon-menu
        style="height: 100%"
        [iconMenuItems]="iconMenuItems()"></dv-icon-menu>
    }
    @if (userData(); as userData) {
      <dv-toolbar-menu
        [username]="userData.name"
        [userEmail]="userData.email"
        [client]="clientName() || ''"
        [predefinedMenuItemsList]="menuItems()">
      </dv-toolbar-menu>
    }
  </dv-toolbar>
  <div class="page__content">
    <dv-nav-menu
      closeText="{{ 'General.Close' | translate }}"
      openText="{{ 'General.Open' | translate }}"
      [navItems]="navItems()"
      [isOpen]="isNavMenuOpen()"
      (open)="navMenuToggled(true)"
      (close)="navMenuToggled(false)"></dv-nav-menu>
    <div class="page__routes">
      <dv-alert-banner
        [type]="'warning'"
        [isVisible]="(displayBannerTrigger$ | async) === true"
        [actionText]="'Release.ReloadNow' | translate"
        [contentText]="'Release.NewVersionAvailable' | translate"
        [actionFn]="reloadApp" />
      <router-outlet />
    </div>
  </div>
</div>
